import { client } from '@/proxy/client'
import { gql } from 'graphql-request'
import { useQuery, type UseQueryHookOptions } from '@/proxy/react-query'
import type { SellerInfo } from '@/resources/types/seller'

export type SellerInfoData = {
  seller: SellerInfo
}

export const SELLER_INFO = gql`
  query sellerInfo {
    seller {
      id
      name
      status
      allowPiiSharing
      isOrdersExpeditionEnabled
      owner {
        name
      }
      document
      emails {
        address
        type
      }
      phones {
        number
        category
      }
      mainPhoneNumber
      address {
        street
        number
        city
        location {
          coordinates
        }
        provinceCode
        province
        countryCode
        complement
        neighborhood
        postcode
      }
      shop {
        workDays {
          weekDay
          enabled
          intervals {
            openingTime
            closingTime
          }
        }
        coverageArea {
          type
          coordinates
        }
        turboCoverageArea
      }
      sellerOpenedEditModal {
        count
        lastUpdate
      }
      sellerClosedTestOrder {
        count
        lastUpdate
      }
      sellerOrderEdit {
        count
        lastUpdate
      }
      category
    }
  }
`
export const SELLER_INFO_KEY = 'useSellerInfo'

export const useSellerInfo = (options?: UseQueryHookOptions<SellerInfoData>) =>
  useQuery<SellerInfoData>({
    queryKey: [SELLER_INFO_KEY],
    queryFn: () => client.request(SELLER_INFO),
    ...options,
  })
